import React, { useEffect, useState } from 'react';
import { Spinner, useStateContext } from '@veda/dashboard-ui';
import { usePppApi } from '../services/pppApi';

export default function ReportRitardiRup() {
  const { _locate } = useStateContext();
  const api = usePppApi();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.reportRitardiRup({
      onSuccess: (data) => { setReport(data); setLoading(false); },
      onError:   ()     => setLoading(false),
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="p-6">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">
          {_locate('ppp_report_ritardi_titolo')}
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          {_locate('ppp_report_ritardi_sottotitolo')}
        </p>
      </div>

      {loading && (
        <div className="flex justify-center h-40 items-center">
          <Spinner />
        </div>
      )}

      {!loading && report && (
        <>
          <div className="flex items-center gap-4 mb-4">
            <span className={`text-2xl font-bold ${report.totaleRitardi > 0 ? 'text-red-600' : 'text-green-600'}`}>
              {report.totaleRitardi}
            </span>
            <span className="text-sm text-gray-500">
              {report.totaleRitardi === 1 ? 'ritardo rilevato' : 'ritardi rilevati'}
              {report.rupNome ? ` — ${report.rupNome}` : ''}
            </span>
          </div>

          {report.totaleRitardi === 0 ? (
            <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
              <p className="text-green-700 font-medium">{_locate('ppp_report_nessun_ritardo')}</p>
            </div>
          ) : (
            <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
              <table className="min-w-full divide-y divide-gray-200 text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wide text-xs">
                      {_locate('ppp_report_col_procedimento')}
                    </th>
                    <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wide text-xs">
                      {_locate('ppp_report_col_scadenza')}
                    </th>
                    <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wide text-xs">
                      {_locate('ppp_report_col_data')}
                    </th>
                    <th className="px-4 py-3 text-right font-medium text-gray-500 uppercase tracking-wide text-xs">
                      {_locate('ppp_report_col_ritardo')}
                    </th>
                    <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wide text-xs hidden lg:table-cell">
                      {_locate('ppp_report_col_normativa')}
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100">
                  {report.scadenze.map((s, i) => (
                    <tr key={i} className="hover:bg-gray-50 transition-colors">
                      <td className="px-4 py-3">
                        <div className="font-medium text-gray-900 leading-tight">{s.titoloProcedimento}</div>
                        {s.codiceProcedimento && (
                          <div className="text-xs text-gray-400 mt-0.5">{s.codiceProcedimento}</div>
                        )}
                      </td>
                      <td className="px-4 py-3 text-gray-600">{s.descrizione}</td>
                      <td className="px-4 py-3 text-gray-600 whitespace-nowrap">
                        {new Date(s.dataScadenza).toLocaleDateString('it-IT')}
                      </td>
                      <td className="px-4 py-3 text-right">
                        <span className="inline-flex items-center justify-center rounded-full bg-red-100 text-red-700 font-bold px-2.5 py-0.5 text-xs min-w-[3rem]">
                          +{s.giorniRitardo}gg
                        </span>
                      </td>
                      <td className="px-4 py-3 text-gray-400 text-xs italic hidden lg:table-cell">
                        {s.riferimentoNormativo}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
      </div>{/* fine card */}
    </div>
  );
}
